function createBreadcrumb(
  breadcrumb,
) {
  return {
    timestamp: new Date().getTime() / 1000,
    type: 'default',
    ...breadcrumb,
  };
}

export { createBreadcrumb };
//# sourceMappingURL=createBreadcrumb.js.map
